// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"a38e77c8","841":"4314bc9b","996":"a38e77c8"}[chunkId] + ".chunk.css";
};